import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,_vm._g(_vm._b({attrs:{"color":"secondary","icon":"","small":""}},'v-btn',{ ..._vm.$props, ..._vm.$attrs },false),_vm.$listeners),[(_vm.icon)?_c(VIcon,{attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }